export class CookieConsentModel {
  Version: number = 0;
  Functional: boolean = false;
  Analytics: boolean = false;
  Marketing: boolean = false;
}
